{
	"core": {
		"general": {
			"fieldValidationNotMatchingError": "{{fieldLabel}} does not match",
			"fieldValidationNumberError": "{{fieldLabel}} must be a number",
			"fieldValidationRequiredError": "{{fieldLabel}} is required",
			"fieldValidationNumberOverMaxError": "{{fieldLabel}} must be at or under {{max}}",
			"fieldValidationNumberUnderMinError": "{{fieldLabel}} must be at or over {{min}}",

			"exerciseActivityTypeBasketball": "Basketball",
			"exerciseActivityTypeBoxing": "Boxing",
			"exerciseActivityTypeCycling": "Cycling",
			"exerciseActivityTypeDance": "Dance",
			"exerciseActivityTypeElliptical": "Elliptical",
			"exerciseActivityTypeOther": "Other",
			"exerciseActivityTypeRunning": "Running",
			"exerciseActivityTypeSoccer": "Soccer",
			"exerciseActivityTypeSwimming": "Swimming",
			"exerciseActivityTypeTennis": "Tennis",
			"exerciseActivityTypeWalking": "Walking",
			"exerciseActivityTypeWeightLifting": "Weight Lifting",
			"exerciseActivityTypeYoga": "Yoga",
			"mealTypeBreakfast": "Breakfast",
			"mealTypeDinner": "Dinner",
			"mealTypeLunch": "Lunch",
			"mealTypeSnacks": "Snacks",
			"ratingType1": "Super Sad",
			"ratingType2": "Sad",
			"ratingType3": "Happy",
			"ratingType4": "Awesome",
			"sexTypeFemale": "Female",
			"sexTypeMale": "Male"
		},
		"moduleDetails": {
			"title": "Module",
			"title_1": "Patient Welcome",
			"title_2": "Exercise",
			"title_3": "Food Fundamentals 1",
			"title_4": "Food Fundamentals 2",
			"title_5": "Food Fundamentals 3",
			"title_6": "Macronutrients",
			"title_7": "Meal Makeover",
			"title_8": "Hydration",
			"title_9": "Vitamins and Minerals",
			"title_10": "Post-Op Life 1",
			"title_11": "Post-Op Life 2",
			"title_12": "Post-Op Life 3"
		},
		"lessonDetails": {
			"title": "Class",
			"title_1-1": "Patient Welcome",
			"title_1-2": "Obesity Is a Disease",
			"title_2-1": "Exercise",
			"title_3-1": "The System Is Broken",
			"title_3-2": "The System Is Fixed",
			"title_3-3": "Weight Loss Surgery",
			"title_4-1": "What Is Food For?",
			"title_4-2": "Diet Food Fiasco",
			"title_5-1": "Sugar",
			"title_5-2": "Calories",
			"title_5-3": "Food Labels 101",
			"title_6-1": "Protein",
			"title_6-2": "Carbohydrates",
			"title_6-3": "Fats",
			"title_7-1": "Meal Mindset: Healthy Plate",
			"title_7-2": "Meal Planning",
			"title_8-1": "Hydration",
			"title_9-1": "Vitamins and Minerals",
			"title_10-1": "Diet Progression",
			"title_10-2": "Eating for the New You",
			"title_11-1": "Risks",
			"title_11-2": "Support and Accountability",
			"title_11-3": "Positive Habit Change",
			"title_12-1": "Myth Busters",
			"title_12-2": "The Bottom Line",
			"title_12-3": "Goal Setting",
			"description": "NewTri® Health is a video-based, interactive educational program that prepares you for successful bariatric surgery and gives you the tools to stay healthy for the rest of your life.",
			"description_1-2": "Believe it or not, you’ve just made one of the most important decisions of your life.\n\nLearn the multitude of damages and dangers that people escape when they break free from obesity.",
			"description_2-1": "Is exercise worth the effort? That depends. Many people expect exercise to do something that it simply can’t.\n\nFind out what that is, then learn the benefits you can expect the active lifestyle that’s right for you.",
			"description_3-1": "There’s a reason why diets and medications don’t work. Actually, there are several reasons.\n\nLet’s take a look at why weight-loss systems fail and leave you feeling trapped in a condition you’ve tried so hard to escape.",
			"description_3-2": "If diets and medications can’t help us overcome obesity, what can?\n\nTake heart. You can win back your health, and you’re about to learn the formula that works. Check out the four steps we will spend the rest of this course unpacking.",
			"description_3-3": "We do ourselves a huge favor when we exercise and change our relationship with food. It’s tempting to stop there and sidestep weight loss surgery. Here’s the thing: Surgery transforms our bodies in two crucial ways.\n\nLearn about those changes in this video.",
			"description_4-1": "When we establish a new relationship with food, we develop a deeper understanding of what food does. Without a doubt, we are meant to enjoy food, but first have to know its purpose.\n\nLet’s redefine our understanding of food, and take look at two basic categories of nutrition.",
			"description_4-2": "Breaking news: Advertisers don’t always tell the whole truth. Food packaging often distorts reality in ways that work against our health.\n\nLearn to look past the labels. Here’s what fat-free products usually hide and what to look for so that your well-intentioned choices actually help your body lose weight.",
			"description_5-1": "What makes the sugar in a strawberry better than the sugar in, say, strawberry ice cream?\n\nHere’s how our bodies react to sugar. We’ll look at the chemical we produce to transform sweetness into fuel, and what happens when we eat things that trigger our bodies to make too much of that chemical.",
			"description_5-2": "If you want to lose weight, you’ll find a lot of tools that help count calories. Unfortunately, calorie counts leave out the information you really need. You have to know what kinds of energy you’re giving your body.\n\nThis video reveals the type of calories to avoid and the ones that fuel our energy, our strength, and our well-being.",
			"description_5-3": "Remember this: If a food has a label, you should read it. The government keeps companies honest with these labels, and they can help you choose the right kinds and quantities of fuel for your day.\n\nWhen you read a label, pay attention to these key facts and use the guidelines in this video to choose the right kinds of fuel.",
			"description_6-1": "Now, let’s talk about the big category of nutrients that makes your body feel full, increase metabolism, and burn body fat. Did we mention that it maintains and increases muscle and replenishes energy?\n\nWe’re talking about protein. Learn how much of this macronutrient to look for per meal, as well as per day. Also, know which proteins to choose, even if you don’t eat meat.",
			"description_6-2": "When you study nutrition, you might begin to believe that you should avoid all carbohydrates. As it turns out, that’s not the case. Some carbs provide fiber, long-term energy, and nutrients for our digestive systems. We need them — in moderation.\n\nThis video reveals the best kind of carbs and offers a simple trick to make sure you’re eating the right amount of carbs today.",
			"description_6-3": "Which major category of nutrients confuses people the most? The answer, of course, is fat. That’s because some types of fat pose massive threats to our health. Meanwhile, other types of fat are so important that they should make up a third of what we eat every day.\n\nLearn how to avoid the harmful fats and make the helpful ones a key part of what fuels your body.",
			"description_7-1": "Now that you have a better understanding of your macronutrients — proteins, carbs, and fats — let’s talk about when this knowledge matters most, mealtime. What percentage of your plate should go to each macro?\n\nWe’ll give you a simple way to picture your plate so that you can keep your ratios right.",
			"description_7-2": "Let’s be honest. There’s nothing sexy about meal planning. Nonetheless, choosing what you’re going to eat in advance protects you from the consequences of skipping meals and compulsive eating.\n\nCheck out these three steps to becoming intentional about your meals.",
			"description_8-1": "What’s the number one way to avoid complications after weight-loss surgery? Drink lots of water. You might face some resistance on this because your new stomach will feel full fast.\n\nThis video gives you some simple tricks to getting enough water and giving your body the hydration it needs to build the new you.",
			"description_9-1": "It’s ironic. The broken system leads us to eat more than our bodies need, but we end up lacking essential building blocks like vitamins and micronutrients.\n\nWatch how a few supplements support us and protect us from deficiencies, especially following weight-loss surgery.",
			"description_10-1": "After your weight loss surgery, you’ll want to be gentle on your stomach to help it heal. And the best way to avoid complications during recovery is to stick to the diet sequence laid out by your doctor.\n\nLet’s get an overview of the way your meals will progress during those key weeks of change.",
			"description_10-2": "Often, people feel anxious about how their eating patterns will change after surgery. It’s a significant change, so those nerves are understandable.\n\nBut thankfully, if you follow these tips and guidelines during recovery, you’ll have nothing to worry about.",
			"description_11-1": "Every story contains challenges, risks, and conflict. You’re at the beginning of an inspiring new story, and you’ll have many opportunities to overcome real resistance, even in your own mind.\n\nThis video highlights the need to nurture our mindsets and emotions and find plenty of support along the way.",
			"description_11-2": "No one invests in weight loss surgery because they want to be healthy for a little while. Unfortunately, patients face a ton of pressures that can unravel their hard-earned progress.\n\nThis video explains why the relationships you nurture can make or break your weight-loss journey.",
			"description_11-3": "Here’s a question: What’s the difference between a desire and a goal? People who have succeeded in transforming their health tell us that the right kind of goals are far more likely to improve our habits than lofty ambitions.\n\nCheck out these tips for setting goals and what to do on days when we miss them.",
			"description_12-1": "It’s no secret that our world is buzzing with misinformation about weight loss. We’ve also heard more than a few false notions about weight loss surgery. Let’s set the record straight, so that you can keep moving in the right direction.",
			"description_12-2": "Congratulations! By completing this course, you’ve given yourself a wealth of insight into weight loss surgery and the healthy life. Hopefully, this knowledge has bolstered your confidence that you can and will succeed. To refresh your memory, let’s take a look back at some of key takeaways from this course.",
			"description_12-3": "What do you do when the road gets long? We’ve talked about the importance of developing a healthy mindset about weight loss. Part of that means that we remember what motivated us in the first place, our why.\n\nYou can return to this video whenever you need another helping of purpose."
		},
		"questionDetails": {
			"text": "Unknown question. Please contact your program administrator.",
			"text_1-2-6": "Obesity leads to?",
			"text_1-2-7": "Obesity can lead to",
			"text_1-2-8": "What BMI categorizes obesity?",
			"text_1-2-9": "What effect does weight loss surgery have on the health issues associated with morbid obesity?",
			"text_2-1-0": "Which of these is a benefit of exercise?",
			"text_2-1-1": "How does exercise affect your weight?",
			"text_2-1-2": "Exercise needs to be highly strenuous in order to be effective.",
			"text_2-1-3": "If you miss a day of exercise, what should you do?",
			"text_2-1-4": "How should you determine what sort of exercises to do?",
			"text_2-1-5": "Exercise habits should be:",
			"text_3-1-0": "What should be the goal of a weight-loss system?",
			"text_3-1-1": "Fad diets and pills have been proven to help patients lose weight and keep it off for good.",
			"text_3-1-2": "Why don’t diets work?",
			"text_3-1-3": "What is the key to making permanent changes for your health?",
			"text_3-1-4": "Which is <emphasis>not</emphasis> a side effect of diet pills?",
			"text_3-1-5": "The risk of adverse effects when taking diet pills increases when you have pre-existing conditions.",
			"text_3-2-0": "All of the following are components of the current broken weight-loss system <emphasis>except</emphasis>?",
			"text_3-2-1": "Which of the following is not part of the formula for success?",
			"text_3-2-2": "Once you’ve lost weight, what’s the most important thing you can do to stay healthy for the long run?",
			"text_3-2-3": "Exercise habits should be:",
			"text_3-2-4": "In order to improve your mindset for weight loss, you must change your:",
			"text_3-2-5": "Non-scale victories (NSVs) are victories that:",
			"text_3-3-0": "Weight loss surgery is a critical part of the weight loss formula",
			"text_3-3-1": "Weight loss surgery can help with all of the following <emphasis>except</emphasis>...",
			"text_3-3-2": "Weight loss surgery helps prevent, improve, or resolve over 40 obesity related diseases including:",
			"text_3-3-3": "The metabolic changes that occur after weight loss surgery help:",
			"text_4-1-0": "What is the best way to think about food?",
			"text_4-1-1": "Macronutrients are",
			"text_4-1-2": "Micronutrients include",
			"text_4-1-3": "Micronutrients regulate heart rate and metabolism and help prevent diseases.",
			"text_4-2-0": "Foods labeled fat free are better for you.",
			"text_4-2-1": "When foods are labeled as fat free, what does this usually mean?",
			"text_4-2-2": "At the grocery store, how do you decide if a packaged food is good for you?",
			"text_4-2-3": "Which of these causes you to gain weight?",
			"text_5-1-0": "Excess sugar is stored as",
			"text_5-1-1": "A good philosophy to have about sugar is",
			"text_5-1-2": "Sugar is",
			"text_5-1-3": "The sugar in a half cup of strawberries is the same as the sugar content in a half cup of strawberry ice cream.",
			"text_5-2-0": "If you compare an egg versus a slice of white bread, they have the same calories. Therefore, they are equally nutritious.",
			"text_5-2-1": "When comparing an egg versus a slice of bread, which one is better for you and why?",
			"text_5-2-2": "Why does counting calories not work?",
			"text_5-2-3": "It is better to choose foods with high amounts of protein instead of foods with high amounts of carbohydrates, even if the high protein foods have slightly more calories.",
			"text_5-3-0": "What’s the first thing you should look at on a food label?",
			"text_5-3-1": "You should avoid a food that contains which of the following:",
			"text_5-3-2": "What do you want to try to limit to 15 grams per day?",
			"text_5-3-3": "Which do you want 35 grams of per meal?",
			"text_6-1-0": "Protein helps you",
			"text_6-1-1": "All foods are equally as good for you if they contain the same amount of protein.",
			"text_6-1-2": "The best protein sources are",
			"text_6-1-3": "Which percentage of your meal should be protein?",
			"text_6-1-4": "Protein is the most important macronutrient after surgery.",
			"text_6-2-0": "Which type of carbohydrate is not as good for your health and weight loss?",
			"text_6-2-1": "Complex carbohydrates are found in",
			"text_6-2-2": "Complex carbohydrates are better for you than simple carbohydrates because of all of the following reasons <emphasis>except</emphasis>:",
			"text_6-2-3": "To calculate net carbohydrates",
			"text_6-2-4": "Stay under this amount of net carbohydrates if you are trying to lose weight:",
			"text_6-3-0": "Which type of fat should you avoid entirely?",
			"text_6-3-1": "Which foods have a good amount of unsaturated fat?",
			"text_6-3-2": "Unsaturated fats help",
			"text_6-3-3": "Saturated fat may help in some of the same ways as unsaturated fats, but they should be eating in moderation. Which food is an example of a saturated fat?",
			"text_7-1-0": "How many ounces of lean protein should you aim for at each meal?",
			"text_7-1-1": "What is one of the easiest things you can do to prevent yourself from overeating and ensure you are consuming smaller portions?",
			"text_7-1-2": "What rule helps ensure you get a good balance of foods at each meal?",
			"text_7-1-3": "Non-starchy vegetables should be consumed once you get filled up on protein.",
			"text_7-1-4": "Lean protein should",
			"text_7-1-5": "Once your plate is set, what should you always eat first?",
			"text_7-2-0": "Skipping meals can",
			"text_7-2-1": "All of the following are basic rules to health meal planning <emphasis>except</emphasis>:",
			"text_7-2-2": "How can you prevent yourself from eating too many snacks?",
			"text_7-2-3": "How should you handle eating out?",
			"text_7-2-4": "You should <emphasis>always</emphasis> eat three meals per day.",
			"text_8-1-0": "Dehydration is the number one reason people are hospitalized after surgery.",
			"text_8-1-1": "Ways to avoid dehydration post-surgery include all of the following <emphasis>except</emphasis>:",
			"text_8-1-2": "How much water should you try to consume every day?",
			"text_8-1-3": "Which beverage should be avoided, because it contains a large amount of sugar?",
			"text_9-1-0": "After surgery, vitamin supplements are not essential since you will get all of the vitamins and minerals you need from food alone.",
			"text_9-1-1": "Iron helps with:",
			"text_9-1-2": "When choosing vitamins, make sure they are:",
			"text_9-1-3": "The supplement(s) every patient needs to take after surgery include:",
			"text_9-1-4": "At least how many hours apart from the calcium citrate should the multivitamin be taken?",
			"text_10-1-0": "The most important thing you can do to give your stomach time to heal and avoid complications is follow the diet progression prescribed by your surgeon.",
			"text_10-1-1": "The first stage in the diet progression is",
			"text_10-1-2": "An example of a pureed food is",
			"text_10-1-3": "What food should be avoided on a regular diet?",
			"text_10-2-0": "If you experience nausea from water, try",
			"text_10-2-1": "You should avoid alcohol, because",
			"text_10-2-2": "In order to make better choices when grocery shopping, do all of the following <emphasis>except</emphasis>:",
			"text_10-2-3": "When eating in a restaurant,",
			"text_10-2-4": "If you feel like food is stuck, drink something to help it pass through.",
			"text_11-1-0": "The goal of weight loss surgery is to thrive in all of the following ways <emphasis>except</emphasis>:",
			"text_11-1-1": "Anxiety and depression can be common post-op.",
			"text_11-1-2": "Patients who have weight loss surgery can be at risk for:",
			"text_11-1-3": "One reason some patients experience depression following surgery is",
			"text_11-2-0": "Research has shown ongoing accountability and support makes a difference between temporary and permanent weight loss.",
			"text_11-2-1": "Examples of someone in your life sabotaging your weight loss include all of the following <emphasis>except</emphasis>:",
			"text_11-2-2": "A good support system is someone who is willing to",
			"text_11-2-3": "A good way to determine if you have been successful after surgery is to compare your weight loss to someone else who had the same surgery.",
			"text_11-3-0": "In order to make sustainable lifestyle changes, you need to form new habits.",
			"text_11-3-1": "The best way to form new habits includes",
			"text_11-3-2": "An example of a measurable goal is",
			"text_11-3-3": "All of the following are examples of an achievable goal <emphasis>except</emphasis>:",
			"text_11-3-4": "It is very possible to form good habits overnight.",
			"text_12-1-0": "What are the reasons why weight loss surgery is <emphasis>not</emphasis> the easy route?",
			"text_12-1-1": "All of the following are true regarding weight loss surgery <emphasis>except</emphasis>:",
			"text_12-1-2": "Following weight loss surgery, you will feel like you are starving all the time.",
			"text_12-1-3": "After the initial adjustment period, you will be able to enjoy all of the following <emphasis>except</emphasis>:",
			"text_12-2-0": "The best fuel for weight loss is",
			"text_12-2-1": "In order to lose weight and get healthy, you should",
			"text_12-2-2": "Attention to protein and not calorie counting is one of the most important keys to weight loss.",
			"text_12-2-3": "In order to form healthy habits long term, you should",
			"text_12-3-0": "Common feelings that drive patients to have weight loss surgery include all of the following <emphasis>except</emphasis>:",
			"text_12-3-1": "Examples of goals for the future include",
			"text_12-3-2": "Goals should be",
			"text_12-3-3": "You have created goals. This program has given you what you need to achieve them.",
			"text_12-3-4": "It is essential to have good motivators and support in order to achieve your goals."
		},
		"answerDetails": {
			"text": "Unknown option. Please contact your program administrator.",
			"text_1-2-6-0": "A: A negative self-image",
			"text_1-2-6-1": "B: Experiencing discrimination",
			"text_1-2-6-2": "C: Social isolation",
			"text_1-2-6-3": "D: Lower quality of life",
			"text_1-2-6-4": "E: Susceptibility to depression",
			"text_1-2-6-5": "F: All of the above",
			"text_1-2-7-0": "A: Pulmonary disease (example: obstructive sleep apnea)",
			"text_1-2-7-1": "B: Liver disease (example: NASH (nonalcoholic fatty liver disease))",
			"text_1-2-7-2": "C: Gynecologic abnormalities (example: PCOS (polycystic ovarian syndrome))",
			"text_1-2-7-3": "D: Coronary heart disease",
			"text_1-2-7-4": "E: All of the above",
			"text_1-2-8-0": "A: BMI > 15 kg/m²",
			"text_1-2-8-1": "B: BMI > 20 kg/m²",
			"text_1-2-8-2": "C: BMI > 25 kg/m²",
			"text_1-2-8-3": "D: BMI > 30 kg/m²",
			"text_1-2-9-0": "A: Increases your risk of cancer",
			"text_1-2-9-1": "B: Reduces your risk of death from type 2 diabetes",
			"text_1-2-9-2": "C: Causes joint pain",
			"text_1-2-9-3": "D: Raises your risk of premature mortality",
			"text_2-1-0-0": "A: Jumps start your immune system",
			"text_2-1-0-1": "B: Stress Reduction",
			"text_2-1-0-2": "C: Boosts Energy",
			"text_2-1-0-3": "D: Improves Mood",
			"text_2-1-0-4": "E: All of the above",
			"text_2-1-1-0": "A: Exercise helps you lose a significant amount of weight",
			"text_2-1-1-1": "B: Exercise helps you maintain your weight",
			"text_2-1-1-2": "C: Exercise causes you to gain a lot of weight",
			"text_2-1-1-3": "D: Exercise does not affect your weight",
			"text_2-1-2-0": "A: True",
			"text_2-1-2-1": "B: False",
			"text_2-1-3-0": "A: Do a double the next day",
			"text_2-1-3-1": "B: Quit forever",
			"text_2-1-3-2": "C: Go easy on yourself and follow your plan for the next day",
			"text_2-1-3-3": "D: Skip a meal",
			"text_2-1-4-0": "A: Follow what your friend is doing",
			"text_2-1-4-1": "B: Figure out what fits best with your life and current fitness/health goals",
			"text_2-1-4-2": "C: Do whatever is most excruciating",
			"text_2-1-4-3": "D: Try the latest fad",
			"text_2-1-5-0": "A: Fun",
			"text_2-1-5-1": "B: Challenging",
			"text_2-1-5-2": "C: Sustainable",
			"text_2-1-5-3": "D: Fit into your lifestyle",
			"text_2-1-5-4": "E: All of the above",
			"text_3-1-0-0": "A: To lose as much weight as possible",
			"text_3-1-0-1": "B: To find the right medication to help you lose weight",
			"text_3-1-0-2": "C: To achieve a healthy weight and sustain it for the rest of your life",
			"text_3-1-0-3": "D: To develop the willpower to master a list of dietary rules",
			"text_3-1-1-0": "A: True",
			"text_3-1-1-1": "B: False",
			"text_3-1-2-0": "A: Most diets are not sustainable",
			"text_3-1-2-1": "B: Diets often neglect to give the reasons behind their rules",
			"text_3-1-2-2": "C: At some point, all diets end",
			"text_3-1-2-3": "D: Many diets set unrealistic expectations that leave people discouraged",
			"text_3-1-2-4": "E: All of the above",
			"text_3-1-3-0": "A: Finding a fad diet that works best for you",
			"text_3-1-3-1": "B: Admitting that you have a problem",
			"text_3-1-3-2": "C: Possessing the self-control to never relapse",
			"text_3-1-3-3": "D: Acquiring the knowledge and tools to lose weight and maintain a healthy lifestyle",
			"text_3-1-4-0": "A: Stomach issues",
			"text_3-1-4-1": "B: Nervousness",
			"text_3-1-4-2": "C: Heart palpitations",
			"text_3-1-4-3": "D: Increased hunger",
			"text_3-1-5-0": "A: True",
			"text_3-1-5-1": "B: False",
			"text_3-2-0-0": "A: Fad diets",
			"text_3-2-0-1": "B: Magical meds",
			"text_3-2-0-2": "C: Weight loss medications",
			"text_3-2-0-3": "D: The advice to “eat less” and “exercise more”",
			"text_3-2-0-4": "E: Improving your lifestyle and relationship with food",
			"text_3-2-1-0": "A: Exercise",
			"text_3-2-1-1": "B: Weight-loss surgery",
			"text_3-2-1-2": "C: Trying new fad diets",
			"text_3-2-1-3": "D: A new mindset",
			"text_3-2-1-4": "E: A new relationship with food",
			"text_3-2-2-0": "A: Start following a calorie-counting diet",
			"text_3-2-2-1": "B: Starting taking diet pills",
			"text_3-2-2-2": "C: Never eat meat again",
			"text_3-2-2-3": "D: Continue to work on lifestyle changes and your relationship with food",
			"text_3-2-2-4": "E: None of the above",
			"text_3-2-3-0": "A: Fun",
			"text_3-2-3-1": "B: Challenging",
			"text_3-2-3-2": "C: Sustainable",
			"text_3-2-3-3": "D: Fit into your lifestyle",
			"text_3-2-3-4": "E: All of the above",
			"text_3-2-4-0": "A: Attitude",
			"text_3-2-4-1": "B: Emotions",
			"text_3-2-4-2": "C: Habits",
			"text_3-2-4-3": "D: All of the above",
			"text_3-2-4-4": "E: None of the above",
			"text_3-2-5-0": "A: Cannot be measured on the scale",
			"text_3-2-5-1": "B: Are achieved only after the first year",
			"text_3-2-5-2": "C: Are personal and may not reflect the number on the scale",
			"text_3-2-5-3": "D: Are few and far between",
			"text_3-2-5-4": "E: A & C",
			"text_3-2-5-5": "F: None of the above",
			"text_3-3-0-0": "A: True",
			"text_3-3-0-1": "B: False",
			"text_3-3-1-0": "A: Decreasing the risk of premature death by 30–40%",
			"text_3-3-1-1": "B: Helping you develop a new mindset",
			"text_3-3-1-2": "C: Helping you stay healthy and keep the weight off",
			"text_3-3-1-3": "D: Preventing obesity related diseases",
			"text_3-3-2-0": "A: Type II Diabetes Mellitus",
			"text_3-3-2-1": "B: Obstructive Sleep Apnea",
			"text_3-3-2-2": "C: Heart Disease",
			"text_3-3-2-3": "D: Certain Cancers",
			"text_3-3-2-4": "E: All of the above",
			"text_3-3-3-0": "A: Reduce hunger",
			"text_3-3-3-1": "B: Increase feelings of fullness",
			"text_3-3-3-2": "C: Make it easier to burn more calories",
			"text_3-3-3-3": "D: All of the above",
			"text_4-1-0-0": "A: Food is the enemy",
			"text_4-1-0-1": "B: Food is not meant to be enjoyed",
			"text_4-1-0-2": "C: Food is fuel",
			"text_4-1-0-3": "D: Food is something to eat when you are bored",
			"text_4-1-1-0": "A: Protein, Fats, and Carbohydrates",
			"text_4-1-1-1": "B: What give you energy",
			"text_4-1-1-2": "C: What you need the most of in your diet",
			"text_4-1-1-3": "D: Are present in most foods you eat",
			"text_4-1-1-4": "E: All of the above",
			"text_4-1-2-0": "A: Protein",
			"text_4-1-2-1": "B: Vitamins and minerals",
			"text_4-1-2-2": "C: Carbohydrates",
			"text_4-1-2-3": "D: Water and fiber",
			"text_4-1-2-4": "E: B & D",
			"text_4-1-3-0": "A: True",
			"text_4-1-3-1": "B: False",
			"text_4-2-0-0": "A: True",
			"text_4-2-0-1": "B: False",
			"text_4-2-1-0": "A: It’s the healthiest option available",
			"text_4-2-1-1": "B: It’s good for you",
			"text_4-2-1-2": "C: The fat has been replaced with things that aren’t good for you",
			"text_4-2-1-3": "D: It has fewer calories and fewer harmful ingredients",
			"text_4-2-2-0": "A: If it is labeled diet or low calorie",
			"text_4-2-2-1": "B: If the nutritional information says it has zero fat",
			"text_4-2-2-2": "C: If the ingredient list has few ingredients and looks nutritious",
			"text_4-2-2-3": "D: If the store clerk says it is good for you",
			"text_4-2-3-0": "A: Sugar",
			"text_4-2-3-1": "B: Preservatives",
			"text_4-2-3-2": "C: Additives",
			"text_4-2-3-3": "D: All of the above",
			"text_4-2-3-4": "E: None of the above",
			"text_5-1-0-0": "A: Energy for you to use when you need it",
			"text_5-1-0-1": "B: Fat",
			"text_5-1-0-2": "C: It is not stored at all",
			"text_5-1-0-3": "D: Muscle",
			"text_5-1-1-0": "A: Items with added sugar should be minimized or avoided",
			"text_5-1-1-1": "B: It should be limited to one dessert a day",
			"text_5-1-1-2": "C: It’s not that bad",
			"text_5-1-1-3": "D: If you exercise, you can burn off the excess sugar you eat",
			"text_5-1-2-0": "A: What causes more insulin to be produced in your body",
			"text_5-1-2-1": "B: What causes your fat cells to grow",
			"text_5-1-2-2": "C: Toxic",
			"text_5-1-2-3": "D: The number one cause of obesity",
			"text_5-1-2-4": "E: All of the above",
			"text_5-1-3-0": "A: True",
			"text_5-1-3-1": "B: False",
			"text_5-2-0-0": "A: True",
			"text_5-2-0-1": "B: False",
			"text_5-2-1-0": "A: The bread, because it gives you energy",
			"text_5-2-1-1": "B: The egg, because it contains healthy fats and lean protein",
			"text_5-2-1-2": "C: They are both good for you and equally nutritious",
			"text_5-2-1-3": "D: None of the above",
			"text_5-2-2-0": "A: It’s not an exact science",
			"text_5-2-2-1": "B: All calories are not created equal",
			"text_5-2-2-2": "C: It is not sustainable",
			"text_5-2-2-3": "D: Calories don’t tell you about the nutrition in the food, which is more important",
			"text_5-2-2-4": "E: All of the above",
			"text_5-2-3-0": "A: True",
			"text_5-2-3-1": "B: False",
			"text_5-3-0-0": "A: Sugar content",
			"text_5-3-0-1": "B: Fat content",
			"text_5-3-0-2": "C: Sodium level",
			"text_5-3-0-3": "D: Serving size",
			"text_5-3-0-4": "E: Protein content",
			"text_5-3-1-0": "A: Saturated fat",
			"text_5-3-1-1": "B: Trans fat",
			"text_5-3-1-2": "C: Unsaturated fat",
			"text_5-3-1-3": "D: None of the above — all fat is good for you",
			"text_5-3-2-0": "A: Fats",
			"text_5-3-2-1": "B: Sodium",
			"text_5-3-2-2": "C: Calories",
			"text_5-3-2-3": "D: Sugar",
			"text_5-3-2-4": "E: Protein",
			"text_5-3-3-0": "A: Fat",
			"text_5-3-3-1": "B: Carbohydrates",
			"text_5-3-3-2": "C: Protein",
			"text_5-3-3-3": "D: Fiber",
			"text_5-3-3-4": "E: None of the above",
			"text_6-1-0-0": "A: Feel Full",
			"text_6-1-0-1": "B: Have energy",
			"text_6-1-0-2": "C: Protect from muscle loss",
			"text_6-1-0-3": "D: Burn fat",
			"text_6-1-0-4": "E: All of the above",
			"text_6-1-1-0": "A: True",
			"text_6-1-1-1": "B: False",
			"text_6-1-2-0": "A: Lean meats, poultry, and fish",
			"text_6-1-2-1": "B: Whole grains",
			"text_6-1-2-2": "C: Fruits and vegetables",
			"text_6-1-2-3": "D: Nuts and seeds",
			"text_6-1-3-0": "A: 25%",
			"text_6-1-3-1": "B: 40%",
			"text_6-1-3-2": "C: 75%",
			"text_6-1-3-3": "D: 100%",
			"text_6-1-4-0": "A: True",
			"text_6-1-4-1": "B: False",
			"text_6-2-0-0": "A: Simple",
			"text_6-2-0-1": "B: Complex",
			"text_6-2-1-0": "A: Beans",
			"text_6-2-1-1": "B: Vegetables",
			"text_6-2-1-2": "C: Fruits",
			"text_6-2-1-3": "D: Whole grains",
			"text_6-2-1-4": "E: All of the above",
			"text_6-2-2-0": "A: They contain vitamins and minerals",
			"text_6-2-2-1": "B: They give your body energy",
			"text_6-2-2-2": "C: They are easier to digest",
			"text_6-2-2-3": "D: They contain fiber",
			"text_6-2-2-4": "E: They keep you full longer",
			"text_6-2-3-0": "A: Subtract carbohydrates from protein",
			"text_6-2-3-1": "B: Subtract added sugar from total carbohydrates",
			"text_6-2-3-2": "C: Subtract grams of dietary fiber from grams of carbohydrates",
			"text_6-2-3-3": "D: Add carbohydrates to dietary fiber",
			"text_6-2-3-4": "E: None of the above",
			"text_6-2-4-0": "A: 100 grams",
			"text_6-2-4-1": "B: 20 grams",
			"text_6-2-4-2": "C: 50 grams",
			"text_6-2-4-3": "D: 15 grams",
			"text_6-2-4-4": "E: Do not eat any carbohydrates at all",
			"text_6-3-0-0": "A: Unsaturated fat",
			"text_6-3-0-1": "B: Saturated fat",
			"text_6-3-0-2": "C: All fat",
			"text_6-3-0-3": "D: Trans fat",
			"text_6-3-0-4": "E: None of the above",
			"text_6-3-1-0": "A: Meat, eggs, and milk",
			"text_6-3-1-1": "B: French fries and processed foods",
			"text_6-3-1-2": "C: Nuts, seeds, and olive oil",
			"text_6-3-1-3": "D: Candy, cookies, and cakes",
			"text_6-3-1-4": "E: None of the above",
			"text_6-3-2-0": "A: Lower bad cholesterol",
			"text_6-3-2-1": "B: Protect your heart",
			"text_6-3-2-2": "C: Decrease inflammation",
			"text_6-3-2-3": "D: Keep your skin and hair soft",
			"text_6-3-2-4": "E: All of the above",
			"text_6-3-3-0": "A: Cream",
			"text_6-3-3-1": "B: Bacon",
			"text_6-3-3-2": "C: Butter",
			"text_6-3-3-3": "D: Full-fat cheese",
			"text_6-3-3-4": "E: All of the above",
			"text_7-1-0-0": "A: 5–6 ounces per meal",
			"text_7-1-0-1": "B: 8–9 ounces per meal",
			"text_7-1-0-2": "C: 3–4 ounces per meal",
			"text_7-1-0-3": "D: 2–3 ounces per meal",
			"text_7-1-1-0": "A: Measure out all of your foods",
			"text_7-1-1-1": "B: Weigh all of your foods",
			"text_7-1-1-2": "C: Use a smaller plate",
			"text_7-1-1-3": "D: Drink a lot of water with your meal",
			"text_7-1-2-0": "A: 30/30/40 rule (30% vegetables/30% simple carbs/40% protein)",
			"text_7-1-2-1": "B: 25/50/25 rule (25% lean protein first/50% non-starchy vegetables/25% complex carbs)",
			"text_7-1-2-2": "C: 50/50 rule (50% complex carbs/50% protein)",
			"text_7-1-2-3": "D: 75/25 rule (75% simple carbs/25% vegetables)",
			"text_7-1-3-0": "A: True",
			"text_7-1-3-1": "B: False",
			"text_7-1-4-0": "A: Be consumed first",
			"text_7-1-4-1": "B: Be avoided",
			"text_7-1-4-2": "C: Be eaten sparingly",
			"text_7-1-4-3": "D: Be the only thing consumed in your diet",
			"text_7-1-5-0": "A: Carbohydrates",
			"text_7-1-5-1": "B: Vegetables",
			"text_7-1-5-2": "C: Protein",
			"text_7-1-5-3": "D: You can eat whichever you want first",
			"text_7-2-0-0": "A: Reduce your energy",
			"text_7-2-0-1": "B: Make it difficult to exercise",
			"text_7-2-0-2": "C: Raise your risk of diabetes",
			"text_7-2-0-3": "D: Lead to unhealthy overeating and binging",
			"text_7-2-0-4": "E: All of the above",
			"text_7-2-1-0": "A: Eat 3 meals per day",
			"text_7-2-1-1": "B: Eat snacks whenever you feel hungry",
			"text_7-2-1-2": "C: Limit grazing throughout the day",
			"text_7-2-1-3": "D: Plan ahead",
			"text_7-2-2-0": "A: Eliminate snacks altogether",
			"text_7-2-2-1": "B: Only eat one snack a day at the same time every day",
			"text_7-2-2-2": "C: Eat the same snacks every day",
			"text_7-2-2-3": "D: Plan balanced snacks in advance",
			"text_7-2-2-4": "E: None of the above",
			"text_7-2-3-0": "A: Never do it",
			"text_7-2-3-1": "B: Eat somewhere that does not serve dessert",
			"text_7-2-3-2": "C: Look at the menu ahead of time to decide what you want",
			"text_7-2-3-3": "D: Allow yourself to eat at least one meal out per week",
			"text_7-2-3-4": "E: None of the above",
			"text_7-2-4-0": "A: True",
			"text_7-2-4-1": "B: False",
			"text_8-1-0-0": "A: True",
			"text_8-1-0-1": "B: False",
			"text_8-1-1-0": "A: Carrying a water bottle around everywhere you go",
			"text_8-1-1-1": "B: Drinking 6–8 ounces every hour",
			"text_8-1-1-2": "C: Drinking plenty of caffeinated beverages",
			"text_8-1-1-3": "D: Aiming for 64 ounces of sugar free fluid every day",
			"text_8-1-2-0": "A: 48 ounces",
			"text_8-1-2-1": "B: 32 ounces",
			"text_8-1-2-2": "C: 24 ounces",
			"text_8-1-2-3": "D: 6 ounces",
			"text_8-1-2-4": "E: > 64 ounces",
			"text_8-1-3-0": "A: Juice",
			"text_8-1-3-1": "B: Soda",
			"text_8-1-3-2": "C: Gatorade",
			"text_8-1-3-3": "D: Lemonade",
			"text_8-1-3-4": "E: All of the above",
			"text_9-1-0-0": "A: True",
			"text_9-1-0-1": "B: False",
			"text_9-1-1-0": "A: Energy",
			"text_9-1-1-1": "B: Focus",
			"text_9-1-1-2": "C: Immunity",
			"text_9-1-1-3": "D: Heart Function",
			"text_9-1-1-4": "E: All of the above",
			"text_9-1-2-0": "A: Gummies",
			"text_9-1-2-1": "B: Men’s vitamins",
			"text_9-1-2-2": "C: Senior vitamins",
			"text_9-1-2-3": "D: All of the above are acceptable",
			"text_9-1-2-4": "E: None of the above are acceptable",
			"text_9-1-3-0": "A: Zinc",
			"text_9-1-3-1": "B: Multivitamin",
			"text_9-1-3-2": "C: Biotin",
			"text_9-1-3-3": "D: Calcium Citrate and Vitamin D",
			"text_9-1-3-4": "E: B & D",
			"text_9-1-4-0": "A: 4 hours",
			"text_9-1-4-1": "B: 1 hour",
			"text_9-1-4-2": "C: 2 hours",
			"text_9-1-4-3": "D: 3 hours",
			"text_10-1-0-0": "A: True",
			"text_10-1-0-1": "B: False",
			"text_10-1-1-0": "A: Solid foods",
			"text_10-1-1-1": "B: Pureed diet",
			"text_10-1-1-2": "C: Full liquids",
			"text_10-1-1-3": "D: Clear liquids",
			"text_10-1-1-4": "E: Soft foods",
			"text_10-1-2-0": "A: Deli meat",
			"text_10-1-2-1": "B: An apple",
			"text_10-1-2-2": "C: Baby food",
			"text_10-1-2-3": "D: Well-cooked broccoli",
			"text_10-1-2-4": "E: A chicken breast cut into small pieces",
			"text_10-1-3-0": "A: Healthy fats",
			"text_10-1-3-1": "B: Lean protein",
			"text_10-1-3-2": "C: Starches",
			"text_10-1-3-3": "D: Non-starchy vegetables",
			"text_10-1-3-4": "E: Fresh fruit",
			"text_10-2-0-0": "A: Drinking it really fast to make sure you get it all in",
			"text_10-2-0-1": "B: Fruit juice instead",
			"text_10-2-0-2": "C: Warming it or drinking it at room temperature",
			"text_10-2-0-3": "D: Having sparkling, carbonated water",
			"text_10-2-1-0": "A: It provides empty calories",
			"text_10-2-1-1": "B: It can cause dehydration",
			"text_10-2-1-2": "C: It can aggravate the stomach",
			"text_10-2-1-3": "D: You are at an increased risk of alcohol addiction after surgery",
			"text_10-2-1-4": "E: All of the above",
			"text_10-2-2-0": "A: Choose real foods",
			"text_10-2-2-1": "B: Only shop the inner aisles",
			"text_10-2-2-2": "C: Stick to the outside of the store",
			"text_10-2-2-3": "D: Choose foods with five or less ingredients",
			"text_10-2-3-0": "A: Do not order a beverage or bread",
			"text_10-2-3-1": "B: Share an entrée with a friend",
			"text_10-2-3-2": "C: Have them wrap half of your meal to go before you even start eating",
			"text_10-2-3-3": "D: Plan ahead",
			"text_10-2-3-4": "E: All of the above",
			"text_10-2-4-0": "A: True",
			"text_10-2-4-1": "B: False",
			"text_11-1-0-0": "A: Mentally",
			"text_11-1-0-1": "B: Physically",
			"text_11-1-0-2": "C: Emotionally",
			"text_11-1-0-3": "D: All of the above are needed to thrive",
			"text_11-1-1-0": "A: True",
			"text_11-1-1-1": "B: False",
			"text_11-1-2-0": "A: Eating disorders",
			"text_11-1-2-1": "B: Relationship struggles",
			"text_11-1-2-2": "C: New addictions",
			"text_11-1-2-3": "D: “Buyer’s Remorse” (regretting having the surgery)",
			"text_11-1-2-4": "E: All of the above",
			"text_11-1-3-0": "A: They are losing weight too quickly",
			"text_11-1-3-1": "B: They have to buy new clothes",
			"text_11-1-3-2": "C: They lose a lot of weight in the beginning, and it eventually slows or plateaus",
			"text_11-1-3-3": "D: They are able to do things they have never been able to do before",
			"text_11-2-0-0": "A: True",
			"text_11-2-0-1": "B: False",
			"text_11-2-1-0": "A: Your boss bringing in donuts to work",
			"text_11-2-1-1": "B: Your spouse buying your favorite ice cream",
			"text_11-2-1-2": "C: Your co-working encouraging you to walk with them at lunch",
			"text_11-2-1-3": "D: Your sister baking you a cake for your birthday",
			"text_11-2-2-0": "A: Listen",
			"text_11-2-2-1": "B: Comfort you",
			"text_11-2-2-2": "C: Hold you accountable",
			"text_11-2-2-3": "D: Affirm your fears",
			"text_11-2-2-4": "E: All of the above",
			"text_11-2-3-0": "A: True",
			"text_11-2-3-1": "B: False",
			"text_11-3-0-0": "A: True",
			"text_11-3-0-1": "B: False",
			"text_11-3-1-0": "A: First knowing your bad habits",
			"text_11-3-1-1": "B: Making goals measurable and achievable",
			"text_11-3-1-2": "C: Being realistic",
			"text_11-3-1-3": "D: Managing expectations",
			"text_11-3-1-4": "E: All of the above",
			"text_11-3-2-0": "A: I will eat better",
			"text_11-3-2-1": "B: I will exercise more",
			"text_11-3-2-2": "C: I will aim for 3,000 steps every day by walking at work",
			"text_11-3-2-3": "D: I will eat less",
			"text_11-3-3-0": "A: I will start by walking on the treadmill for 5 minutes each day",
			"text_11-3-3-1": "B: I have never run before, but I will sign up for a marathon this year",
			"text_11-3-3-2": "C: I drink 3 sodas a day and will start by only drinking 2 sodas a day",
			"text_11-3-3-3": "D: I always skip breakfast but will start by having something small each day",
			"text_11-3-4-0": "A: True",
			"text_11-3-4-1": "B: False",
			"text_12-1-0-0": "A: It is a formula: weight loss surgery + changing your understanding and relationship with food + getting more active + mental health strategies = <emphasis>lifelong success</emphasis>",
			"text_12-1-0-1": "B: Results are not guaranteed. The ultimate amount of weight loss is directly proportional with a patient’s efforts.",
			"text_12-1-0-2": "C: The weight loss surgery portion is the easiest hour of the entire process. However, if all criteria of the formula are not met, it will not be successful.",
			"text_12-1-0-3": "D: Obesity is an aggressive, deadly disease, and weight loss surgery is the most effective treatment.",
			"text_12-1-0-4": "E: All of the above",
			"text_12-1-1-0": "A: The risk of dying from bariatric surgery is about the same as for gallbladder surgery.",
			"text_12-1-1-1": "B: Bariatric surgery mortality rates have declined steadily over the years; mortality rates are now less than a fraction of a percent.",
			"text_12-1-1-2": "C: More than 15% of patients will have a heart attack during surgery.",
			"text_12-1-1-3": "D: It is riskier to <emphasis>not</emphasis> have weight loss surgery due to the possible health complications associated with obesity.",
			"text_12-1-2-0": "A: True",
			"text_12-1-2-1": "B: False",
			"text_12-1-3-0": "A: A variety of healthy foods",
			"text_12-1-3-1": "B: High protein foods",
			"text_12-1-3-2": "C: A lot of foods high in sugar and fat",
			"text_12-1-3-3": "D: Low carbohydrate foods",
			"text_12-2-0-0": "A: Trans fat",
			"text_12-2-0-1": "B: Lean protein",
			"text_12-2-0-2": "C: Carbohydrates",
			"text_12-2-0-3": "D: Fiber",
			"text_12-2-0-4": "E: Sugar",
			"text_12-2-1-0": "A: Skip breakfast if you aren’t hungry",
			"text_12-2-1-1": "B: Eat three meals per day even if you aren’t hungry",
			"text_12-2-1-2": "C: Snack, pick, and graze frequently to keep yourself satisfied",
			"text_12-2-1-3": "D: Eat carbohydrates first for energy",
			"text_12-2-2-0": "A: True",
			"text_12-2-2-1": "B: False",
			"text_12-2-3-0": "A: Pace your journey to protect yourself from burn-out",
			"text_12-2-3-1": "B: Focus on fixing your mindset",
			"text_12-2-3-2": "C: Connect with people who support you",
			"text_12-2-3-3": "D: Focus on your “<emphasis>why</emphasis>”",
			"text_12-2-3-4": "E: All of the above",
			"text_12-3-0-0": "A: Tired",
			"text_12-3-0-1": "B: Broken",
			"text_12-3-0-2": "C: Content",
			"text_12-3-0-3": "D: Hopeless",
			"text_12-3-1-0": "A: Being able to be in a picture without being self-conscious",
			"text_12-3-1-1": "B: Walking without assistance",
			"text_12-3-1-2": "C: Getting restful sleep",
			"text_12-3-1-3": "D: Living a long life with the people you love",
			"text_12-3-1-4": "E: All of the above",
			"text_12-3-2-0": "A: Realistic",
			"text_12-3-2-1": "B: Very challenging",
			"text_12-3-2-2": "C: Measurable",
			"text_12-3-2-3": "D: Discouraging",
			"text_12-3-2-4": "E: A & C",
			"text_12-3-3-0": "A: True",
			"text_12-3-3-1": "B: False",
			"text_12-3-4-0": "A: True",
			"text_12-3-4-1": "B: False"
		}
	},
	"web": {
		"general": {
			"days": "{{count, number}} days",
			"days_one": "{{count, number}} day",
			"months": "{{count, number}} months",
			"months_one": "{{count, number}} month",

			"loadingMessage": "Loading...",

			"saveButton": "Save",
			"cancelButton": "Cancel",

			"headerLabel": "NewTri",
			"headerUserMenuLabel": "User",
			"headerUserMenuOptionProfile": "Profile",
			"headerUserMenuOptionAdminDashboard": "Admin Dashboard",
			"headerUserMenuOptionLogOut": "Log Out",

			"profileEmailAddressInput": "Email Address",
			"profileFirstNameInput": "First Name",
			"profileLastNameInput": "Last Name",
			"profileCellPhoneNumberInput": "Cell Phone Number",
			"profileDateOfBirthInput": "Date of Birth",
			"profileSexInput": "Gender",

			"calendarPreviousMonthButton": "Previous Month",
			"calendarNextMonthButton": "Next Month",

			"modalCloseLabel": "Close",
			"confirmationModalConfirmButton": "Yes",
			"confirmationModalCancelButton": "No",

			"expandableAlertExpandLabel": "Expand",
			"expandableAlertCollapseLabel": "Collapse",

			"paceSelectOption": "$t(general.days, { \"count\": {{days}} }) ($t(general.months, { \"count\": {{months}} }))",

			"homeDashboardTab": "Dashboard",
			"homeVideoCourseTab": "Video Course",
			"homePatientResourcesTab": "Patient Resources",
			"homeSupportTab": "Support",

			"courseHeader": "Pre-Op Education for Weight Loss Surgery Patients",
			"courseModuleAvailabilityMessage": "This module will be available to you {{date, datetime(month: long; day: numeric)}}.",
			"courseModuleAvailabilitySoonMessage": "This module will be available to you soon.",
			"courseModuleBeginButton": "Begin {{moduleName}}",
			"courseModuleContinueButton": "Continue {{moduleName}}",
			"courseProgressMessage": "My course progress {{progress, number(style: percent)}} complete",
			"courseCompletionHeader": "Congratulations on Completing the NewTri Course!",

			"certificateDownloadLabel": "Download Completion Certificate",
			"certificateDownloadButton": "Download Certificate",
			"certificateDownloadModalHeader": "Download Certificate",
			"certificateDownloadModalMessage": "What would you like to include in the certificate of completion? You can always change your mind and generate it again.",
			"certificateDownloadModalCoverLetterInput": "Cover Letter — an explanation of the NewTri program for insurers and other payers to provide context for the remaining content of the certificate.",
			"certificateDownloadModalCertificateOfCompletionInput": "Certificate of Completion — the official certificate indicating completion of the NewTri program.",
			"certificateDownloadModalSummaryOfProgressInput": "Summary of Progress — high-level information charts showing logging and quiz scores over the duration of the program.",
			"certificateDownloadModalDetailedReportInput": "Detailed Report — all individual logging for food, exercise, and weight, as well as the assessment results for all 25 classes.",
			"certificateDownloadModalDownloadButton": "Download",

			"patientResourcesMessage": "These links are provided by your selected Bariatric Program. Clicking on a link will take you to a third-party website, which is not managed by NewTri Health. We cannot guarantee the accuracy of any third-party website. You will be subject to the destination website’s privacy policy when you follow the link.",
			"patientResourcesDeleteButton": "delete",

			"patientSupportMessage": "If you are having technical difficulties with the NewTri site, contact <reference>support@newtrihealth.com</reference>.",

			"inactiveLogOutMessage": "We noticed you haven’t done anything for a while. For your protection, we will automatically log you out when the below clock runs out. If you’re still there, just click “Stay Logged In”.",
			"inactiveLogOutTitle": "Are you still there?",
			"inactiveLogOutStayLoggedInButton": "Stay Logged In",
			"inactiveLogOutLogOutButton": "Log Out"
		},
		"account": {
			"header": "Edit Your Profile",
			"informationHeader": "Account Information",
			"membershipDateMessage": "You became a full member on {{date, datetime(dateStyle: long)}}.",
			"avatarLabel": "user avatar",
			"completeProfileMessage": "Please fill out your profile below.",
			"incompleteProfileError": "Please fill out your profile before continuing.",

			"paymentMessage": "In order to access the NewTri course, please make a payment using the form below.",
			"discountCodeMessage": "If you have a discount code, enter it here:",
			"oneTimePaymentOption": "Make a one time payment of {{amount, currency(USD)}} <highlight>(a savings of {{discountAmount, currency(USD)}}!)</highlight>",
			"paymentPlanOption": "Make {{installments, number}} monthly payments of {{amount, currency(USD)}}",
			"submitPaymentButton": "Submit Payment",
			"updatePaymentButton": "Update Payment",
			"payPalOptionMessage": "Or pay with PayPal",
			"payPalPaymentDetailsMessage": "The 3 month payment plan is only available when paying by credit card. This will charge one payment of {{amount, currency(USD)}}.",
			"paymentError": "There was a problem processing your payment. Please contact support.",
			"paymentSuccessMessage": "Thank you for your payment. Your account has been updated!",
			"paymentMethodUpdatedMessage": "Your account has been updated!",

			"saveProfileButton": "Save Changes",
			"cancelProfileChangesButton": "Cancel",
			"profileChangesSaved": "Your changes have been saved!",

			"billingHeader": "Billing",
			"billingActivatedDateMessage": "You activated NewTri on {{date, datetime}}.",
			"billingActivatedDateAndChangeMessage": "You activated NewTri on {{date, datetime}}. We charged {{amount, currency(USD)}}.",
			"billingActivatedDateAndChangeMessage_stripe": "You activated NewTri on {{date, datetime}}. We charged {{amount, currency(USD)}} to the credit card ending in {{cardLast4Digits}}.",
			"billingActivatedDateAndChangeMessage_paypal": "You activated NewTri on {{date, datetime}}. We charged {{amount, currency(USD)}} to your PayPal account.",
			"subscriptionExpiredError": "Your payment method on file was declined. Please update your payment information.",

			"credentialsHeader": "Account Credentials",
			"changeEmailAddressButton": "Change Email Address",
			"emailAddressChangeRequestMessage": "Verification email sent. Follow the instructions in the email to finish updating your email address.",
			"emailAddressChangeLinkError": "The link you used to change your email address is for a different account. Please sign in with the correct account before using the link again.",
			"emailAddressUpdatedMessage": "Your email address has been updated!",
			"currentPasswordInput": "Current Password",
			"newPasswordInput": "New Password",
			"changePasswordButton": "Change Password",
			"currentPasswordError": "The current password was not correct",
			"passwordChangeLinkError": "The reset link is no longer valid. Please try again.",
			"passwordChangeEmailMessage": "A reset email has been sent to the address provided.",
			"passwordChangeSuccessMessage": "Your new password has been set!",

			"completionCodeError": "That is an invalid code",

			"mobileAppRecommendationMessage": "We highly recommend you use our mobile apps:",
			"appleAppStoreLabel": "Apple App Store",
			"googlePlayStoreLabel": "Google Play Store"
		},
		"signup": {
			"header": "Create your NewTri account:",
			"instructionsMessage": "A confirmation email will be sent to this address. Follow the instructions in the email to continue setting up your account.",
			"awaitingConfirmationMessage": "A confirmation email has been sent to {{emailAddress}}. Follow the instructions in the email to continue setting up your account.",
			"cellPhoneNumberWarningMessage": "Message and data rates may apply.",
			"passwordInput": "Password",
			"passwordRequirementsMessage": "Passwords must be at least 8 characters long and consist of at least one of each of the following: an uppercase letter, a lowercase letter, a number, and a special character.",
			"providerInput": "Select Practice",
			"providerInputNoneOption": "Start NewTri without a Practice",
			"surgeonInput": "Select Surgeon",
			"acceptTermsAndConditionsInput": "I have read and understood the <reference>Terms & Conditions</reference>",
			"acceptPrivacyPolicyInput": "I have read and understood the <reference>Privacy Policy</reference>",
			"submitButton": "Sign Up",
			"linkExpiredError": "The invite link is no longer valid. Please contact your provider to get a new link.",
			"genericError": "Something went wrong. Please try again."
		},
		"dashboard": {
			"editTodayButton": "Edit Today",
			"saveSuccessMessage": "Your changes have been saved.",
			"saveError": "Failed to save. Please try again.",

			"exerciseHeader": "Exercise Log",
			"exerciseEntryMessage": "Did you exercise <emphasis>{{date, datetime(month: long; day: numeric)}}</emphasis>?",
			"exerciseEntryTodayMessage": "Did you exercise <emphasis>today</emphasis>?",
			"exerciseOption_no": "No",
			"exerciseOption_yes": "Yes",
			"exerciseDetailsMessage": "Add details about your day:",
			"exerciseActivitiesInput": "Exercise Activities",
			"exerciseDurationInput": "Exercise Duration",

			"foodHeader": "Food Log",
			"foodEntryMessage": "How do you feel about what you ate <emphasis>{{date, datetime(month: long; day: numeric)}}</emphasis>?",
			"foodEntryTodayMessage": "How do you feel about what you ate <emphasis>today</emphasis>?",
			"foodDetailsMessage": "Add details about your day:",
			"foodMealTimeInput": "Meal Time",
			"foodMealDescriptionInput": "What did you eat?",
			"foodFrequencyEncouragementMessage": "You logged your food 5 days this week! Nice job!",
			"foodGoodRatingEncouragementMessage": "<paragraph>It looks like you’ve been eating really well this week! Way to go!</paragraph><paragraph>Building and maintaining healthy eating habits now will make all the difference in the world through the rest of your weight loss journey.</paragraph>",

			"weightHeader": "Weight Log",
			"weightEntryMessage": "What did you weigh <emphasis>{{date, datetime(month: long; day: numeric)}}</emphasis>?",
			"weightEntryTodayMessage": "What did you weigh <emphasis>today</emphasis>?",
			"weightWithingsConnectButton": "Connect to Withings",
			"weightWithingsDisconnectButton": "Disconnect from Withings",
			"weightWithingsReconnectButton": "Reconnect to Withings",
			"weightWithingsConnectionError": "NewTri lost the connection to your Withings account. <action>Click here to reconnect it</action>.",
			"weightWithingsScaleError": "You do not have a scale connected to your Withings account.",
			"weightWithingsGeneralError": "There was a problem communicating with Withings.",
			"weightEncouragementMessage": "<paragraph>Don’t stop logging your weight and exercise! Even if you’re discouraged, it’s important to keep logging these things so you can accurately track your progress and review habits closely with your surgery program.</paragraph><paragraph>It looks like you’ve had a small set back with your weight. Don’t be discouraged, and don’t give up.</paragraph><paragraph>Do make sure to keep logging your weight and exercise — this will help your surgeon track your habits and progress, so they can best help you keep pushing forward.</paragraph>",

			"quizAverageHeader": "Quiz Average"
		},
		"course": {
			"availableDateMessage": "Available: {{date, datetime(dateStyle: long)}}",
			"releasedDateMessage": "Released: {{date, datetime(dateStyle: long)}}",
			"paymentDeclinedError": "Your payment method on file was declined. Please visit your <reference>Profile</reference> to update your payment information.",
			"paymentMissingError": "Payment is required to view lessons. Please visit your <reference>Profile</reference> to update your payment information.",
			"lessonSubHeader": "Class {{lessonNumber}}",
			"lessonVideoTab": "Video",
			"lessonKeyFactsTab": "Key Facts",
			"lessonArticleTab": "Article",
			"lessonQuizTab": "Quiz",

			"lessonQuizUnavailableMessage": "Please watch the video to unlock the quiz.",
			"lessonQuizExplanationMessage": "The following assessment will test your comprehension of the materials provided this week. Once you begin the assessment you will have 10 minutes to complete it. You will only be able to take this assessment once.",
			"lessonQuizLoadError": "There was an error loading the questions. Please refresh this page.",
			"lessonQuizStartMessage": "Once you are ready, click “Start” below.",
			"lessonQuizStartButton": "Start",
			"lessonQuizAnswerSaveError": "There was a problem saving your answers. Please reload the page and try again.",
			"lessonQuizSubmitButton": "Submit",
			"lessonQuizResultsHeader": "Assessment Results",
			"lessonQuizFullScoreEncouragementMessage": "You scored 100% on your quiz — way to go! Keep up the great work!",
			"lessonQuizLowScoreEncouragementMessage": "<paragraph>It looks like you had a tough time with the comprehension quiz for this class. Don’t sweat it, it happens.</paragraph><paragraph>If you are feeling stuck or need help understanding the information, you can always contact your surgery program — they’re happy to help!</paragraph><paragraph>And make sure to always review the key fact infographic and supplemental information for each class, before you take the quiz.</paragraph>",
			"lessonQuizResultsMessage": "You correctly answered {{correctAnswerCount}} out of {{questionCount}} questions ({{scorePercent, number(style: percent)}})."
		}
	},
	"mobile": {
		"general": {
			"loadingLabel": "loading",
			"externalLinkHint": "opens in a new window",
			"datePickerHint": "opens calendar",
			"optionPickerCloseButton": "Close",
			"textInputFieldUnitFormat": "{{value}} {{unit}}",
			"genericErrorMessage": "Something went wrong!",
			"genericErrorRetryButton": "Retry",
			"genericErrorShowDetailsButton": "Show Details",
			"genericErrorHideDetailsButton": "Hide Details",
			"unauthorizedErrorMessage": "Session expired. Please sign in again.",
			"textFieldShowSecureTextButton": "Show {{fieldLabel}}",
			"textFieldHideSecureTextButton": "Hide {{fieldLabel}}",

			"passwordRequirementsHeader": "Password Requirements",
			"passwordRequirementCharacters": "At least 8 characters",
			"passwordRequirementUppercase": "An uppercase letter",
			"passwordRequirementLowercase": "A lowercase letter",
			"passwordRequirementNumber": "A number",
			"passwordRequirementSpecial": "A special character",
			"passwordRequirementMetLabel": "{{requirementDescription}}: requirement met",
			"passwordRequirementNotMetLabel": "{{requirementDescription}}: requirement not met"
		},
		"menuBar": {
			"dashboardButton": "Dashboard",
			"educationButton": "Education",
			"resourcesButton": "Resources",
			"profileButton": "Profile"
		},
		"patientResources": {
			"header": "Patient Resources",
			"infoHeader": "What is Patient Resources?",
			"infoContent": "These links are provided by your selected Bariatric Program. Clicking on a link will take you to a third-party website, which is not managed by NewTri Health. We cannot guarantee the accuracy of any third-party website. You will be subject to the destination website’s privacy policy when you follow the link.",
			"infoCloseButton": "Done",
			"infoOpenButton": "open information",
			"noResourcesAvailableMessage": "No resources available."
		},
		"welcome": {
			"imageLabel": "NewTri: new body, new mind, new life",
			"header": "Welcome to NewTri Health",
			"description": "NewTri® Health is a video-based, interactive educational program that prepares you for successful bariatric surgery and gives you the tools to stay healthy for the rest of your life.",
			"continueButton": "Get Started"
		},
		"login": {
			"logoLabel": "NewTri Health",
			"header": "Sign In",
			"emailInput": "Email",
			"passwordInput": "Password",
			"rememberEmailInput": "Remember email",
			"forgotPasswordLink": "Forgot Password?",
			"loginButton": "Sign In",
			"invalidCredentials": "We’re sorry, but your User ID and/or password are invalid.",
			"generalError": "Something went wrong while signing you in. Please try pressing “$t(login.loginButton)” again."
		},
		"resetPassword": {
			"enterEmailHeader": "Reset Password",
			"emailInput": "Email",
			"submitEmailButton": "Reset Password",
			"enterCodeHeader": "Check Email",
			"submitCodeButton": "Verify",
			"changePasswordHeader": "Change Password",
			"codeGenerationErrorMessage": "Something went wrong. Please try pressing “$t(resetPassword.submitEmailButton)” again.",
			"codeSent": "We’ve sent the code to your email <emphasis>{{emailAddress}}</emphasis> if an account exists with that address.",
			"codeExpiration": "Code expires in: <emphasis>{{timeInMinutesAndSeconds}}</emphasis>",
			"codeExpiredError": "The code has expired. Please submit your email again to receive a new code.",
			"maximumAttemptsExceededError": "You entered the code incorrectly too many times or the code is no longer valid. Please submit your email again to receive a new code.",
			"invalidCodeError": "Incorrect code. Please try again.",
			"codeValidationErrorMessage": "Something went wrong while verifying the code. Please try pressing “$t(resetPassword.submitCodeButton)” again.",
			"startOverButton": "Use a different email? <emphasis>Start over.</emphasis>",
			"newPasswordInput": "New Password",
			"passwordConfirmationInput": "Confirm New Password",
			"passwordConfirmationMismatch": "Passwords do not match",
			"submitPasswordButton": "Change Password",
			"sessionExpiredError": "Your session has expired. Please submit your email again to receive a new code.",
			"passwordUpdateError": "Something went wrong while updating your password. Please try pressing “$t(resetPassword.submitPasswordButton)” again.",
			"cancelButton": "Changed your mind? <emphasis>Sign in.</emphasis>",
			"successHeader": "Success!",
			"successMessage": "Your new password has been set!",
			"loginButton": "Sign In"
		},
		"userProfile": {
			"header": "Profile",
			"logoutButton": "Sign Out",
			"nameInput": "Name",
			"firstNameInput": "First Name",
			"lastNameInput": "Last Name",
			"emailInput": "Email",
			"emailUpdateMessage": "We will send a verification email to the address provided. Follow the instructions in the email to finish updating your email address.",
			"cellPhoneNumberInput": "Cell Phone Number",
			"cellPhoneNumberMessage": "Message and data rates may apply.",
			"passwordInput": "Password",
			"currentPasswordInput": "Current Password",
			"newPasswordInput": "New Password",
			"newPasswordConfirmationInput": "Confirm New Password",
			"newPasswordValidationError": "$t(userProfile.newPasswordInput) does not meet the requirements",
			"dateOfBirthInput": "Date of Birth",
			"sexInput": "Sex",
			"missingValueMessage": "Please update",
			"backToProfileButtonLabel": "return to profile",
			"sendEmailVerificationButton": "Send",
			"emailVerificationSentNotice": "Verification email sent.",
			"saveButton": "Save",
			"userLoadFailedError": "An error occurred while loading your profile.",
			"saveFailedError": "Something went wrong while saving your changes. Please try pressing “$t(userProfile.saveButton)” again.",
			"logoutModalHeader": "Sign Out",
			"logoutModalMessage": "Are you sure that you want to sign out of the application?",
			"logoutModalRejectButton": "Cancel",
			"logoutModalApproveButton": "Sign Out"
		},
		"dashboard": {
			"profileLinkLabel": "Profile",
			"selectTodayButton": "Today",
			"addLogButton": "Add",
			"saveFailedError": "Something went wrong while saving your changes. Please try pressing “$t(dashboard.addLogButton)” again.",
			"addLogModalMessage": "As of {{date, datetime(dateStyle: long)}}",

			"exerciseLogHeader": "Exercise",
			"exerciseLogActivitiesHeader": "Activities",
			"addExerciseLogButton": "Add Exercise",
			"updateExerciseLogButton": "Update Exercise",
			"addExerciseLogModalHeader": "Have you exercised?",
			"exerciseYesButton": "Yes",
			"exerciseNoButton": "No",
			"exerciseActivitiesInput": "Exercise Activities",
			"exerciseDurationInput": "Exercise Duration",
			"exerciseDurationHoursInput": "Duration Hours",
			"exerciseDurationMinutesInput": "Duration Minutes",
			"exerciseNoneMessage": "None",

			"weightLogHeader": "Weight",
			"addWeightLogButton": "Add Weight",
			"updateWeightLogButton": "Update Weight",
			"addWeightLogModalHeader": "What is your weight?",
			"weightInput": "Weight",
			"weightLogGraphDurationMessage": "Last 2 weeks",

			"foodLogHeader": "Meals",
			"addFoodLogButton": "Add Meals",
			"addAdditionalMealButton": "Add Meal",
			"addFoodLogModalHeader": "How do you feel about what you ate?",
			"addFoodLogMealModalHeader": "What did you eat?",
			"mealTypeInput": "Meal",
			"mealTimeInput": "Meal Time",
			"mealDescriptionInput": "What did you eat?",
			"ratingHeader": "Rating",
			"removeMealButton": "Remove meal?",
			"removeMealModalHeader": "Remove Meal",
			"removeMealModalMessage": "Are you sure you want to remove this meal?",
			"removeMealModalApproveButton": "Remove",
			"removeMealModalRejectButton": "Cancel",

			"waterLogHeader": "Water",
			"addWaterLogButton": "Add Water",
			"updateWaterLogButton": "Update Water",
			"incrementWaterLogConsumedButton": "Add 8 oz",
			"incrementWaterLogConsumedFailedMessage": "Water update failed. Please try again.",
			"waterLogConsumedHeader": "Consumed",
			"waterLogConsumedDescription_one": "{{count, number}} ounce",
			"waterLogConsumedDescription_other": "{{count, number}} ounces",
			"addWaterLogModalHeader": "How much water have you consumed?",
			"waterAmountInput": "Amount Consumed",
			"waterAmountInputUnit": "oz"
		},
		"education": {
			"header": "Education",
			"quizzesHeader": "Quizzes",
			"quizzesDescription": "Comprehensive Quiz Average",
			"allModulesHeader": "All Modules",
			"moduleReleasedOn": "Released on: {{date, datetime(dateStyle: long)}}",
			"moduleAvailableOn": "Will Be Released on: {{date, datetime(dateStyle: long)}}",
			"playButton": "Play",
			"replayButton": "Replay",
			"lessonCount_one": "{{count, number}} Class",
			"lessonCount_other": "{{count, number}} Classes",
			"quizQuestionCount_one": "{{count, number}} Question",
			"quizQuestionCount_other": "{{count, number}} Questions",
			"resumeLessonHeader": "Resume Class",
			"currentLessonDescription": "Class {{current}} of {{total}}",

			"videoPlayerShowControlsButton": "Show Controls",
			"videoPlayerHideControlsButton": "Hide Controls",
			"videoPlayerPlayButton": "Play",
			"videoPlayerPauseButton": "Pause",
			"backToCourseButton": "Back to Class",
			"videoPlayerPositionLabel": "Playback Position",
			"videoPlayerDurationLabel": "Video Duration",
			"videoPlayerFullscreenButton": "Fullscreen",
			"videoPlayerPositionSliderLabel": "Playback Position",
			"videoRatingMessage": "Have you enjoyed the video?",
			"videoRatingOptionLabel_one": "{{count, number}} star",
			"videoRatingOptionLabel_other": "{{count, number}} stars",
			"videoRatingSubmittedMessage": "Thank you!",

			"lessonHeader": "Class {{lessonNumber}}: {{lessonName}}",
			"lessonDescriptionHeader": "Description",
			"tabClasses": "Classes",
			"tabAbout": "About",
			"tabFacts": "Facts",
			"tabArticle": "Article",
			"tabQuiz": "Quiz",

			"backToLessonButtonLabel": "Back to Class",
			"quizHeader": "Quiz",
			"quizSubmitButton": "Submit Answers",
			"quizResultsHeader": "You correctly answered {{correctAnswerCount}} out of {{questionCount}} questions ({{scorePercentage, number(style: percent)}})",
			"quizResultsLowScoreMessage": "It looks like you had a tough time with the comprehension quiz for this class. Don’t sweat it, it happens.\n\nIf you are feeling stuck or need help understanding the information, you can always contact your surgery program — they’re happy to help!\n\nAnd make sure to always review the key fact infographic and supplemental information for each class before you take the quiz.",
			"quizResultsDoneButton": "Done",
			"quizTabHeader": "Class {{lessonNumber}} Quiz",
			"quizTabDescription": "Take Class {{lessonNumber}} Quiz in order to complete this section.",
			"quizTabStartButton": "Take Quiz",
			"quizTabResumeButton": "Resume Quiz",
			"quizTabViewResultsButton": "View Quiz Results",
			"quizUnavailableAlertTitle": "Not Available",
			"quizUnavailableAlertMessage": "You have to finish watching the lesson before taking the quiz.",
			"quizUnavailableAlertDoneButton": "Done",
			"quizAnswerSaveFailedMessage": "Failed to save answer. Please try again.",

			"completionHeader": "100% Course Completion!",
			"completionMessage": "Congratulations on completing the NewTri Health Course!",
			"completionCertificateButton": "Download Certificate"
		},
		"appInfo": {
			"termsAndConditionsLink": "Terms & Conditions",
			"privacyPolicyLink": "Privacy Policy",
			"viewAppInfoButton": "App Information",
			"header": "App Information",
			"versionDetailsHeader": "Version Details",
			"checkButton": "Check for Update",
			"installButton": "Install Update",
			"lastCheckedMessage": "Last checked: {{time, datetime(dateStyle: long; timeStyle: short)}}",
			"updateAvailableMessage": "New update available!",
			"upToDateMessage": "No new updates available."
		}
	}
}
